import { FC } from "react";

import { FontIcon, FontSizes, Stack, Text, useTheme } from "@bps/fluent-ui";
import { Country } from "@libs/enums/country.enum.ts";
import { AddressType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import {
  Address,
  addressText,
  nzAddressText
} from "@stores/core/models/Address.ts";
import { Contact } from "@stores/practice/models/Contact.ts";
import { AddressTypeText } from "@ui-components/RefText.tsx";

import { sortedAddresses } from "./utils.ts";

type ContactMethodListAddressesProps = {
  contact: Contact;
  asBullet?: boolean;
};

export const ContactMethodListAddresses: FC<
  ContactMethodListAddressesProps
> = ({ contact, asBullet }) => {
  const theme = useTheme();
  return (
    <>
      {sortedAddresses(contact.addresses).map(address => {
        const showAddress = (address: Address): string | JSX.Element => {
          // street2 to use as Building/Facility name for NZ addresses;
          // nzAddress contains the rest of address fields(without street2);
          const { street2, ...nzAddress } = address;

          if (address.country === Country.NewZealand && address.street2) {
            return (
              <>
                {/* street2 to use as Building/Facility name for NZ addresses goes on the first line*/}
                <div>{street2},</div>
                {/* the rest of address fields(without street2) goes on the second ilne*/}
                <div>{nzAddressText(nzAddress)}</div>
              </>
            );
          }
          return addressText(address);
        };

        return (
          <Stack
            key={JSON.stringify(address)}
            styles={{ root: { padding: "0 10px" } }}
          >
            {!asBullet && (
              <Text
                variant="xSmall"
                styles={{ root: { color: theme.palette.neutralSecondary } }}
              >
                {address.type === AddressType.Both ? (
                  "Physical & postal address"
                ) : (
                  <AddressTypeText code={address.type} />
                )}
              </Text>
            )}
            <Stack horizontal tokens={{ childrenGap: 4 }}>
              {asBullet && (
                <FontIcon
                  iconName="RadioBullet"
                  styles={{
                    root: {
                      display: "block",
                      textAlign: "center",
                      fontSize: FontSizes.size10
                    }
                  }}
                />
              )}
              <Text> {showAddress(address)}</Text>
            </Stack>
          </Stack>
        );
      })}
    </>
  );
};
